module.exports = __webpack_public_path__ + "static/financial_access4-6cc009a987456adda79ca2e45505d05b.png";